module.exports = __webpack_public_path__ + "static/16-aerial-views-i-b9586b396a7c1507f83dd4371cd9f2d9.jpg";